<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p style="text-align: center;"><span dir="rtl">شكر وتقدير إلى الكاتب والروائي عبد الله زايد<br/>
الذي شجعني في روايتي الأولى..</span></p>
<p style="text-align: center;"><span dir="rtl">وشكر وتقدير للكاتبة والروائية أسماء الزرعوني<br/>
على دعمي في روايتي الثانية..</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?69862446